import React, { useEffect, useState } from "react";
import * as _ from "lodash";
import Footer from "./common/Footer";
import Introduction from "./common/Introduction";
import ResourcesResume from "./pairComparaison/ResourcesResume";
import RateImageChart from "./pairComparaison/RateImageChart";
import AttributeScatters from "./pairComparaison/AttributeScatters";
import FeedbacksContainer from "./common/FeedbacksContainer";
import { translate } from "utlis/translations/i18n";
import NoResults from "./NoResults";

const PairComparaisonResults = ({ session, results, feedbacks, instances }) => {
  const [loading, setLoading] = useState(true);
  const [maximumPoints, setMaximumPoints] = useState(0);
  const [playedTimes, setPlayedTimes] = useState(0);
  const [preferencesData, setPreferencesData] = useState([]);

  const ref = React.createRef();
  const { metadata, data } = session;
  const resultsDsc = _.orderBy(results, ["points"], ["desc"]);
  const resultsAsc = _.orderBy(results, ["points"], ["asc"]);

  useEffect(() => {
    const preferences = [];
    let totalPoints = 0;
    results.forEach((result, i) => {
      totalPoints += result.points;
    });
    const played = totalPoints / (results.length * (results.length - 1));
    setPlayedTimes(played);
    const maxPoints = played * 2 * data.sequences.length;
    setMaximumPoints(maxPoints);

    resultsAsc.forEach((res, i) => {
      preferences.push({
        name: res.resource.name,
        Evaluation: (res.points / maxPoints).toFixed(2),
        attributes: res.resource.attributes ? res.resource.attributes : false,
      });
      if (i === resultsAsc.length - 1) {
        setPreferencesData(preferences);
        setLoading(false);
      }
    });
    // eslint-disable-next-line
  }, []);

  if (loading) return <div></div>;
  if (playedTimes === "0") return <NoResults />;

  return (
    <div>
      <div className="new-results" ref={ref}>
        <Introduction
          session={session}
          protocol={`${translate("pairwiseComparison")} - ${translate(
            "judgmentOf"
          )} ${session.data.sequencesResources.length} ${translate(
            "situationOutOf"
          )} ${session.data.sequences.length} ${translate("comparisons")}`}
          playedTimes={playedTimes}
          results={results}
        />
        <ResourcesResume resultsDsc={resultsDsc} maximum={maximumPoints} />
        <RateImageChart
          preferencesData={preferencesData}
          maximum={maximumPoints}
          metadata={metadata}
        />
        {metadata.attributes && (
          <AttributeScatters
            attributes={metadata.attributes}
            preferencesData={preferencesData}
          />
        )}
        {feedbacks && feedbacks.length ? (
          <FeedbacksContainer feedbacks={feedbacks} />
        ) : (
          <></>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default PairComparaisonResults;
